import firebase from "firebase/app"
import "firebase/auth"

const firebaseConfig = {
    apiKey: "AIzaSyCUUhW9hVtUbbOLponEp6XITe8blxA2PEA",
    authDomain: "omkarcoolservices-e0d6d.firebaseapp.com",
    projectId: "omkarcoolservices-e0d6d",
    storageBucket: "omkarcoolservices-e0d6d.appspot.com",
    messagingSenderId: "195030148373",
    appId: "1:195030148373:web:7a7cb99ed96d5f1019351c",
    measurementId: "G-PY4BZNHX5E"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// export
export const auth = firebase.auth();
export const googleAuthProvider = new firebase.auth.GoogleAuthProvider();  